export const checkQuantityOfEquals = (array, length) => {
  let count = 0,
    value = array[0];

  return array.some(function(a) {
    if (value !== a) {
      count = 0;
      value = a;
    }
    return ++count === length;
  });
};

export const getAverageRating = (array) => {
  let total = 0;
  for(let i = 0; i < array.length; i++) {
    total += array[i];
  }

  const average =  total / array.length
  return  average.toFixed(1);
}
